// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/connections/public/v1/read_api.proto (package gdx.connections.public.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BatchGetConnectionStateRequest, BatchGetConnectionStateResponse, GetConnectionsStatisticsRequest, GetConnectionsStatisticsResponse, GetDialogRequest, GetDialogResponse, GetUniqueIdRequest, GetUniqueIdResponse, ListBlockedUsersRequest, ListBlockedUsersResponse, ListDialogMessagesRequest, ListDialogMessagesResponse, ListDialogsRequest, ListDialogsResponse, ListMatchesRequest, ListMatchesResponse } from "./read_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gdx.connections.public.v1.ReadAPIService
 */
export const ReadAPIService = {
  typeName: "gdx.connections.public.v1.ReadAPIService",
  methods: {
    /**
     * @generated from rpc gdx.connections.public.v1.ReadAPIService.ListDialogs
     */
    listDialogs: {
      name: "ListDialogs",
      I: ListDialogsRequest,
      O: ListDialogsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.ReadAPIService.ListMatches
     */
    listMatches: {
      name: "ListMatches",
      I: ListMatchesRequest,
      O: ListMatchesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.ReadAPIService.GetDialog
     */
    getDialog: {
      name: "GetDialog",
      I: GetDialogRequest,
      O: GetDialogResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.ReadAPIService.ListDialogMessages
     */
    listDialogMessages: {
      name: "ListDialogMessages",
      I: ListDialogMessagesRequest,
      O: ListDialogMessagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.ReadAPIService.ListBlockedUsers
     */
    listBlockedUsers: {
      name: "ListBlockedUsers",
      I: ListBlockedUsersRequest,
      O: ListBlockedUsersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.ReadAPIService.GetUniqueId
     */
    getUniqueId: {
      name: "GetUniqueId",
      I: GetUniqueIdRequest,
      O: GetUniqueIdResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.ReadAPIService.BatchGetConnectionState
     */
    batchGetConnectionState: {
      name: "BatchGetConnectionState",
      I: BatchGetConnectionStateRequest,
      O: BatchGetConnectionStateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.ReadAPIService.GetConnectionsStatistics
     */
    getConnectionsStatistics: {
      name: "GetConnectionsStatistics",
      I: GetConnectionsStatisticsRequest,
      O: GetConnectionsStatisticsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

